// お問い合わせForm
$(() => {
  if (!document.querySelector('.productForm__form')) return;

  class FetchError extends Error {};

  const {createApp, ref, reactive, computed, watch, nextTick, onMounted, onBeforeUnmount} = Vue;
  const {useVuelidate} = Vuelidate;
  const {required, requiredIf, minValue, email, numeric, sameAs, helpers} = VuelidateValidators;

  const DEFAULT_CONTENT = {
    category: '',
    item: '',
    option1: '',
    option1Title: '',
    option2: '',
    option2Title: '',
    amount: null,
  }

  function buildProductFormMaster(str) {
    const lines = str.trim().split('\n')
    const titles = lines[0].split('\t');
    return lines.slice(1)
      .map(line => {
        return line.split('\t')
          .map((col, index) => ({col: col.trim(), index}))
          .filter(({col}) => col && col !== '-')
          .map(({col, index}) => {
            let value = col.split('、');
            if (value.length >= 2) {
              value = value.map(v => v.trim());
            } else {
              value = value[0];
            }
            return { title: titles[index], value };
          });
    });
  }

  const PRODUCT_FORM_MASTER_DEMO = buildProductFormMaster(PRODUCT_FORM_MASTER_DEMO_STR);
  const PRODUCT_FORM_MASTER_ESTIMATE = buildProductFormMaster(PRODUCT_FORM_MASTER_ESTIMATE_STR);

  const app = createApp({
    setup() {
      const page = ref('input');
      const state = reactive({
        wants: [],
        contents: [{}, {}, {}].map(content => reactive(Object.assign(content, DEFAULT_CONTENT))),
        clinicName: '',
        clinicTel: '',
        clinicAddress: '',
        clinicEmail: '',
        clinicPersonInCharge: '',
        dealer: '',
        dealerBranch: '',
        dealerPersonInCharge: '',
        other: '',
        privacyAgreement: false,
        notesAgreement: false,
      });
      const fetchError = ref('');

      const productFormMaster = ref(PRODUCT_FORM_MASTER_DEMO);
      watch(() => state.wants, () => {
        if (state.wants === 'デモ依頼') {
          productFormMaster.value = PRODUCT_FORM_MASTER_DEMO;
        } else {
          productFormMaster.value = PRODUCT_FORM_MASTER_ESTIMATE;
        }
        state.contents = [{}, {}, {}].map(content => reactive(Object.assign(content, DEFAULT_CONTENT)));
      });

      const rules = {
        wants: {
          required: helpers.withMessage('ご希望する内容を選択してください。', required),
        },
        contents: {
          notEmpty: helpers.withMessage('製品を選択してください。', contents => {
            return contents.some(content => content.category);
          }),
        },
        clinicName: {
          required: helpers.withMessage('貴医院名は必須です。', required),
        },
        clinicTel: {
          required: helpers.withMessage('貴医院電話番号は必須です。', required),
        },
        clinicAddress: {
          required: helpers.withMessage('貴医院住所は必須です。', required),
        },
        clinicEmail: {
          required: helpers.withMessage('貴医院メールアドレスは必須です。', required),
          email: helpers.withMessage('メールアドレスの形式が正しくありません。', email),
        },
        clinicPersonInCharge: {
          required: helpers.withMessage('貴医院ご担当者様名は必須です。', required),
        },
        dealer: {
          required: helpers.withMessage('お取引ディーラー名は必須です。', required),
        },
        dealerBranch: {},
        dealerPersonInCharge: {},
        other: {},
        privacyAgreement: {sameAs: sameAs(true)},
        notesAgreement: {sameAs: sameAs(true)},
      };

      const v$ = useVuelidate(rules, state);

      const confirm = () => {
        page.value = 'confirm';
        setTimeout(() => window.scroll(0, 0), 100);
      };

      const modify = () => {
        fetchError.value = '';
        page.value = 'input';
        setTimeout(() => window.scroll(0, 0), 100);
      }

      const submit = () => {
        fetchError.value = '';

        const server = location.hostname === 'localhost' ? '' : '//app.nsk-dental.com';
        fetch(server + '/product_form/sendmail', {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(state),

        }).then(response => {
          if (response.status !== 200) {
            const contentType = response.headers.get('content-type');
            const isJson = contentType && contentType.indexOf('application/json') !== -1;
            const message = isJson ? response.json().message : '';
            throw new FetchError(message);
          }
          page.value = 'thanks';

        }).catch(error => {
          console.log(error)
          const message = (error instanceof FetchError) ? error.message : null;
          fetchError.value = message || '通信中にエラーが発生しました。少しお待ちいただき、再度ご送信ください。';
          console.log(fetchError.value)
        });
      };

      const updateContent = (index, event) => {
        const content = {...state.contents[index], [event.name]: event.value};
        state.contents[index] = content;
      }

      return { page, state, v$, confirm, modify, submit, fetchError, updateContent, productFormMaster};
    },
  });

  app.component('Content', {
    props: ['index', 'category', 'item', 'option1', 'option1Title', 'option2', 'option2Title', 'amount', 'page', 'wants', 'productFormMaster'],
    setup(props, {emit}) {
      const rules = {
        category: {},
        item: {},
        option1: {},
        option2: {},
        amount: {
          requiredIf: helpers.withMessage('個数は必須です。', requiredIf(() => props.category)),
          numeric: helpers.withMessage('個数は数値で入力してください。', numeric),
          minValue: helpers.withMessage('個数は1以上で入力してください。', minValue(1)),
        },
      }
      const v$ = useVuelidate(rules, props);

      const updateValue = (name, value) => {
        emit(`update`, {name, value});
      }

      const categoriesBeforeUniq = props.productFormMaster.map(master => master[0].value);
      const categories = [...new Set(categoriesBeforeUniq)];

      function isEqual(col, value) {
        if (!col) return false;
        if (Array.isArray(col.value)) {
          return col.value.includes(value);
        } else {
          return col.value === value;
        }
      }

      const items = computed(() => {
        const filtereds = props.productFormMaster.filter(master => master[0].value === props.category);
        const items = filtereds.map(filtered => filtered[1].value);
        return [...new Set(items)];
      })

      const options1 = computed(() => {
        const filtereds = props.productFormMaster.filter(master => {
          return isEqual(master[0], props.category) &&
            isEqual(master[1], props.item);
        });
        if (filtereds.length === 0 || !filtereds[0][2]) return null;
        const options1 = filtereds.flatMap(filtered => filtered[2].value);
        return {
          title: filtereds[0][2].title,
          options: [...new Set(options1)],
        };
      });

      const options2 = computed(() => {
        const filtereds = props.productFormMaster.filter(master => {
          return isEqual(master[0], props.category) &&
            isEqual(master[1], props.item) &&
            isEqual(master[2], props.option1);
        });
        if (filtereds.length === 0 || !filtereds[0][3]) return null;
        const options2 = filtereds.flatMap(filtered => filtered[3].value);
        return {
          title: filtereds[0][3].title,
          options: [...new Set(options2)],
        };
      });

      const popupOpened = ref(false);
      const openPopup = () => {
        // setTimeoutしないとclosePopupOnClickOuterも直後に実行されてpopupOpenedがfalseになる。
        // stopPropagationしても良いが、他のContentのポップアップが開いている場合は閉じてほしいのでこの方法にする。
        setTimeout(() => {
          popupOpened.value = true;
        }, 10);
      }
      const closePopup = () => {
        popupOpened.value = false;
      }
      const closePopupOnClickOuter = e => {
        if (popupOpened.value && !e.target.closest(`.-content${props.index + 1} .productForm__content__popup__inner`)) {
          closePopup();
        }
      }
      onMounted(() => {
        window.addEventListener('click', closePopupOnClickOuter);
      });
      onBeforeUnmount(() => {
        window.removeEventListener('click', closePopupOnClickOuter);
      })


      watch(() => props.category, (to, from) => {
        nextTick(() => {
          updateValue('item', items.value[0] || null);
          if (!from && to) {
            updateValue('amount', 1);
          } else if (!to) {
            updateValue('amount', null);
          }
        });
      });

      watch(() => props.item, () => {
        nextTick(() => {
          let option1 = null;
          let option1Title = null;
          if (options1.value) {
            option1 = options1.value.options[0];
            option1Title = options1.value.title;
          }
          updateValue('option1', option1)
          updateValue('option1Title', option1Title)
        });
      });

      watch(() => props.option1, () => {
        nextTick(() => {
          let option2 = null;
          let option2Title = null;
          if (options2.value) {
            option2 = options2.value.options[0];
            option2Title = options2.value.title;
          }
          updateValue('option2', option2)
          updateValue('option2Title', option2Title)
        });
      });

      return { v$, updateValue, categories, items, options1, options2, popupOpened, openPopup, closePopup };
    },
    template: CONTENT_TEMPLATE,
  });

  app.mount('#productForm');

});

const CONTENT_TEMPLATE = `
  <li class="productForm__content" :class="{ ['-content' + (index + 1)]: true }">
    <div class="productForm__content__inner">
      <p class="productForm__content__index">{{index + 1}}</p>
      <div class="productForm__content__body">
        <div class="productForm__content__conditionsWrapper">
          <dl class="productForm__content__conditions">
            <div class="productForm__content__condition">
              <dt class="productForm__content__condition__title">製品カテゴリ</dt>
              <dd class="productForm__content__condition__body">
                <select v-if="page === 'input'"
                  @input="updateValue('category', $event.target.value)"
                  @blur="v$.category.$touch()"
                  :value="v$.category.$model"
                  class="productForm__content__condition__select">
                  <option value=""></option>
                  <option v-for="category in categories" :key="category" :value="category">{{category}}</option>
                </select>
                <span v-else>{{v$.category.$model}}</span>
              </dd>
            </div>
            <div class="productForm__content__condition">
              <dt class="productForm__content__condition__title">製品名</dt>
              <dd class="productForm__content__condition__body">
                <select v-if="page === 'input'"
                  @input="updateValue('item', $event.target.value)"
                  @blur="v$.item.$touch()"
                  :value="v$.item.$model"
                  :disabled="!category"
                  class="productForm__content__condition__select">
                  <option v-for="item in items" :key="item" :value="item">{{item}}</option>
                </select>
                <span v-else>{{v$.item.$model}}</span>
              </dd>
            </div>
            <div class="productForm__content__condition" v-if="options1">
              <dt class="productForm__content__condition__title">
								{{options1.title}}
								<a v-if="options1.title === 'カップリングジョイントタイプ' && page === 'input'" @click="openPopup"><br>※カップリングジョイントタイプ一覧</a>
							</dt>
              <dd class="productForm__content__condition__body">
                <select v-if="page === 'input'"
                  @input="updateValue('option1', $event.target.value)"
                  @blur="v$.option1.$touch()"
                  :value="v$.option1.$model"
                  class="productForm__content__condition__select">
                  <option v-for="option in options1.options" :key="option" :value="option">{{option}}</option>
                </select>
                <span v-else>{{v$.option1.$model}}</span>
								<transition name="v-popup">
									<aside v-if="popupOpened" class="productForm__content__popup">
										<div class="productForm__content__popup__inner">
											<a @click="closePopup" class="productForm__content__popup__close">
												<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/close.svg" alt="close">
											</a>
											<ul class="productForm__content__popup__cuplings">
												<li class="productForm__content__popup__cupling">
													<figure class="productForm__content__popup__cupling__image">
														<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/cupling_nsk.png" alt="ナカニシ / パテラス(ライト付)" />
													</figure>
													<h6 class="productForm__content__popup__cupling__title">ナカニシ / パテラス(ライト付)</h6>
												</li>
												<li class="productForm__content__popup__cupling">
													<figure class="productForm__content__popup__cupling__image">
														<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/cupling_morita.png" alt="モリタ / αメインチューブ" />
													</figure>
													<h6 class="productForm__content__popup__cupling__title">モリタ / αメインチューブ</h6>
												</li>
												<li class="productForm__content__popup__cupling">
													<figure class="productForm__content__popup__cupling__image">
														<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/cupling_osada.png" alt="オサダ / ファインジョイント" />
													</figure>
													<h6 class="productForm__content__popup__cupling__title">オサダ / ファインジョイント</h6>
												</li>
												<li class="productForm__content__popup__cupling">
													<figure class="productForm__content__popup__cupling__image">
														<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/cupling_yoshida.png" alt="ヨシダ / クイックジョイント" />
													</figure>
													<h6 class="productForm__content__popup__cupling__title">ヨシダ / クイックジョイント</h6>
												</li>
												<li class="productForm__content__popup__cupling">
													<figure class="productForm__content__popup__cupling__image">
														<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/cupling_kavo.png" alt="KaVo® / Multiflex®" />
													</figure>
													<h6 class="productForm__content__popup__cupling__title">KaVo® / Multiflex®</h6>
												</li>
												<li class="productForm__content__popup__cupling">
													<figure class="productForm__content__popup__cupling__image">
														<img src="<?php echo get_template_directory_uri(); ?>/assets/img/product_form/cupling_shirona.png" alt="Sirona® / Quick coupling" />
													</figure>
													<h6 class="productForm__content__popup__cupling__title">Sirona® / Quick coupling</h6>
												</li>
											</ul>
										</div>
									</aside>
								</transition>
              </dd>
            </div>
            <div class="productForm__content__condition" v-if="options2">
              <dt class="productForm__content__condition__title">{{options2.title}}</dt>
              <dd class="productForm__content__condition__body">
                <select v-if="page === 'input'"
                  @input="updateValue('option2', $event.target.value)"
                  @blur="v$.option2.$touch()"
                  :value="v$.option2.$model"
                  class="productForm__content__condition__select">
                  <option v-for="option in options2.options" :key="option" :value="option">{{option}}</option>
                </select>
                <span v-else>{{v$.option2.$model}}</span>
              </dd>
            </div>
          </dl>
        </div>
        <div class="productForm__content__amount">
          <template v-if="page === 'input'">
            <input maxlength="2"
              @input="updateValue('amount', $event.target.value)"
              @blur="v$.amount.$touch()"
              :value="v$.amount.$model"
              :disabled="!category"
              class="productForm__content__amount__textbox">
            <span class="productForm__content__amount__unit">個</span>
          </template>
          <span v-else-if="amount" class="productForm__content__amount__unit">{{v$.amount.$model}}個</span>
        </div>
        <p class="productForm__content__error" v-if="v$.amount.$errors.length">{{v$.amount.$errors[0].$message}}</p>
      </div>
    </div>
  </li>
`;